import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.orderDateTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        color: ${getColor("text.main")};
    `,
}
savedOrderDetailsOrderInformationStyles.orderDateText = {
    css: css`
        color: ${getColor("text.main")};
    `,
}
savedOrderDetailsOrderInformationStyles. shippingAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        color: ${getColor("text.main")};
    `,
}

savedOrderDetailsOrderInformationStyles.shippingAddress = {
  address1Text: {
    as: "p",
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
address2Text: {
    as: "p",
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
address3Text: {
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
address4Text: {
    as: "p",
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
cityText: {
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
companyNameText: {
    as: "p",
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
stateText: {
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
postalCodeText: {
    css: css`
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
    `,
},
}

savedOrderDetailsOrderInformationStyles. billingAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        color: ${getColor("text.main")};
    `,
}
savedOrderDetailsOrderInformationStyles.billingAddress = {
    address1Text: {
      as: "p",
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  address2Text: {
      as: "p",
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  address3Text: {
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  address4Text: {
      as: "p",
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  cityText: {
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  companyNameText: {
      as: "p",
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  stateText: {
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  postalCodeText: {
      css: css`
              font-size: 14px;
              line-height: ${TYPOGRAPHY.lineHeight.base};
              color: ${getColor("text.main")};
      `,
  },
  }

savedOrderDetailsOrderInformationStyles.shippingInformationGridItem = {
    width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    margin-bottom: 12px !important;
                `,
                null,
                null,
            ],
            "min",
        )};
        `,
}
savedOrderDetailsOrderInformationStyles.billingInformationGridItem = {
    width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    margin-bottom: 12px !important;
                `,
                null,
                null,
            ],
            "min",
        )};
        `,
}
  
  